module.exports = __webpack_public_path__ + "static/media/staff.49785c48.png";